import { render } from "./CompliancePage.vue?vue&type=template&id=73977b2b&scoped=true"
import script from "./CompliancePage.vue?vue&type=script&lang=js"
export * from "./CompliancePage.vue?vue&type=script&lang=js"

import "./CompliancePage.vue?vue&type=style&index=0&id=73977b2b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73977b2b"]])

export default __exports__